import { render, staticRenderFns } from "./EquipmentMagic.vue?vue&type=template&id=604bdcfc&scoped=true&"
import script from "./EquipmentMagic.vue?vue&type=script&lang=js&"
export * from "./EquipmentMagic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604bdcfc",
  null
  
)

export default component.exports